import { useFeatureIsOn } from '@growthbook/growthbook-react'

// GrowthBook flag key. Hardcoded locally because pantry-features can't reach
// the host app's `~/constants/flags.ts`. Must stay in sync with the host's
// FLAGS entry if one is added there.
export const BS_PANTRY_UNLINK_POS_STATE = 'bs-pantry-unlink-pos-state'

// Gates the Pantry "Add Product" create flow (the Add Product button on the
// product list + the create-mode product editor). Off is the safe default —
// `useFeatureIsOn` returns false when the flag is unknown or not yet loaded, so
// the list/editor behave exactly as they did before the feature.
export const useUnlinkPosState = (): boolean =>
  useFeatureIsOn(BS_PANTRY_UNLINK_POS_STATE)
